
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/news/[id]",
      function () {
        return require("private-next-pages/airlines/news/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/news/[id]"])
      });
    }
  